import L from "leaflet";
import "leaflet.markercluster";
import { OpenStreetMapProvider } from 'leaflet-geosearch';
import  regeneratorRuntime from "regenerator-runtime";

const spinner = '<div class="load-spin"><div></div><div></div><div></div><div></div></div>';

function calculateDistance(origin, destination) {
    /* Used for calculating distance between multiple coordinates */
    const earthRadius = 6371;

    const toRadians = (angle) => {
        return angle * (Math.PI / 180);
    };

    const lat1 = origin.lat;
    const lon1 = origin.lng;
    const lat2 = destination.lat;
    const lon2 = destination.lng;

    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const distance = earthRadius * c;
    return distance;
}

class PickStoreModal {
    constructor() {
        this.init();
    }

    /**
     * Main method. Used for setting up other methods
     * 
     */
    init() {

        let $ = jQuery;
        let self = this;

        $(document).ready(function () {
            
            // Close to you button
            $('.close-to-you').click(function () {
                let btn = $(this);
                self.closeToYou(btn);
            });

            $('.mm__pick-store-modal .store-card').each(function () {
                self.pickStore($(this));
            });
            
            // Find store form
            $('.mm__pick-store-modal #pick-store').submit(function (e) {
                e.preventDefault();

                jQuery('.error-no-shop').remove();

                self.bindSearchInput($('.mm__pick-store-modal .pick-store-input').val());
            });
        });
    }

     /**
     * Responsible for displaying more information on each store
     * 
     * @param {jQuery selector} $el 
     */
     pickStore($el) {
        $el.on('click', function () {
            if (!$el.hasClass('is-active')) {
                $el.addClass('is-active')
            } else {
                $el.removeClass('is-active')
            }
            $el.children('.btn-wrapper').slideToggle(300);
        });
    }


    /**
     * Close to you button
     * 
     */
    closeToYou(btn) {
        self = this;

        jQuery('.error-no-shop').remove();

        // Add spinner
        jQuery(btn).children().css('visibility', 'hidden');
        jQuery(btn).append(spinner);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                var pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                self.showResult(self, pos);

                // Remove spinner
                jQuery(btn).children('.load-spin').remove();
                jQuery(btn).children().css('visibility', 'visible');
            },
            function(error) {
                if (error.code == error.PERMISSION_DENIED)
                jQuery('.mm__pick-store-modal .search-store').after(
                    '<span class="error-no-shop">Platstjänst ej tillåten</span>'
                );
                // Remove spinner
                jQuery(btn).children('.load-spin').remove();
                jQuery(btn).children().css('visibility', 'visible');
                
            });
        } else {
            alert('Geolocation is not supported by this browser.');
        }
    }

    /**
     * Responsible for displaying results based on either search coordinates or positional coordinates
     * 
     * @param {this} self 
     * @param {object} origin 
     */
    showResult(self, origin) {
        let $ = jQuery;

        $('.mm__pick-store-modal .store-card').each(function (i, el) {
            
            if ($(this).hasClass('is-hidden')) {
                $(this).removeClass('is-hidden');
            }

            let destination = { lat: parseFloat($(this).data('lat')), lng: parseFloat($(this).data('lng')) };

            const distance = calculateDistance(origin, destination);

            if (distance > 100) {
                $(this).addClass('is-hidden');
            } 

            /* Sorts by distance */
            $('.mm__pick-store-modal .store-card').sort(function (a, b) {
                let aDistance = calculateDistance(origin, { lat: parseFloat($(a).data('lat')), lng: parseFloat($(a).data('lng')) });
                let bDistance = calculateDistance(origin, { lat: parseFloat($(b).data('lat')), lng: parseFloat($(b).data('lng')) });

                return aDistance - bDistance;
            }).appendTo('.mm__pick-store-modal .stores-wrapper');

        });

        /* Update amount */
        setTimeout(() => {
            let totalStoreNumber = $('.mm__pick-store-modal .store-card').length;
            let filteredStoreNumber = $('.mm__pick-store-modal .store-card:not(.is-hidden)').length;
            $('.mm__pick-store-modal .number-of-stores').empty();
            $('.mm__pick-store-modal .number-of-stores').text(`${filteredStoreNumber} av ${totalStoreNumber} butiker`);
        }, 1000 );
    }

    bindSearchInput(input) {
        const self = this;
        self.geoCodeSearch(input);
    }

    async geoCodeSearch(searchTerm) {

        // Add spinner
        jQuery('.mm__pick-store-modal .search-store').find('.pre-input').children().css('visibility', 'hidden');
        jQuery('.mm__pick-store-modal .search-store').find('.pre-input').append(spinner);

        const provider = new OpenStreetMapProvider({
            params: {
                countrycodes: "se",
            },
        });
        const results = await provider.search({ query: searchTerm });
        /* Serach result */
        setTimeout(() => {
            if (results.length > 0) {
                const pos = {
                    lat: results[0].y,
                    lng: results[0].x
                };

                this.showResult(self, pos);

                // Remove spinner
                jQuery('.mm__pick-store-modal .search-store').find('.load-spin').remove();
                jQuery('.mm__pick-store-modal .search-store').find('.pre-input').children().css('visibility', 'visible');
                
            } else {
                jQuery('.mm__pick-store-modal .search-store').after('<span class="error-no-shop">Adressen kunde ej hittas</span>');

                // Remove spinner
                jQuery('.mm__pick-store-modal .search-store').find('.load-spin').remove();
                jQuery('.mm__pick-store-modal .search-store').find('.pre-input').children().css('visibility', 'visible');
            }
        }, 1000);
    }
}

export default PickStoreModal;
